import React, { useState, useEffect } from "react";
import api from "../../api";

export default function BottomAd() {
  const [ad, setAd] = useState(null);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    const fetchAd = async () => {
      try {
        const res = await api.get("/add-banners");
        const advisements = res.data?.data?.Advisement || [];

        const bottomLeftAds = advisements.filter(
          (item) => item.position === "Bottom Left" && item.show === "1"
        );

        bottomLeftAds.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        if (bottomLeftAds.length > 0) {
          setAd(bottomLeftAds[0]);
          setImageFailed(false);
        } else {
          setAd(null);
          setImageFailed(false);
        }
      } catch (err) {
        console.error("Failed to load ads:", err);
        setAd(null);
        setImageFailed(false);
      }
    };

    fetchAd();
  }, []);

  const hasRenderableAd = Boolean(ad?.image_video) && !imageFailed;

  return (
    <aside className="bottom-add">
      <div className="ad-section">
        <div className="ad-card d-block">
          {hasRenderableAd ? (
            <a href={ad?.url || "#"} target="_blank" rel="noopener noreferrer">
              <img
                alt="Advertisement"
                className="ad-image mb-0"
                src={ad.image_video}
                onError={() => setImageFailed(true)}
              />
            </a>
          ) : (
            <div className="ad-image ad-image-empty mb-0" aria-hidden="true" />
          )}
        </div>
      </div>
    </aside>
  );
}
